<template>
  <DesignStudioDSHeader
    @designRequest="designRequest"
  />
  <main>
  <div class="container">
    <DesignStudioSectionMain
      @designRequest="designRequest"
    />
    <DesignStudioSectionWhyUs/>
    <DesignStudioSectionServices
      @designRequest="designRequest"
    />
    <DesignStudioSectionGallery/>
    <DesignStudioSectionReviews/>
    <DesignStudioSectionCostProject
      @designRequest="designRequest"
    />
    <DesignStudioReqestModal
      :active="modalActive"
      @close="modalActive = false"
    />
  </div>
  </main>
  <DesignStudioDSFooter />
</template>

<script setup lang="ts">
import {useUserStore} from '~/modules/User/user.store';

const user = useUserStore();
const router = useRouter();
const modalActive = ref(false);

definePageMeta({
  layout: 'null',
});

watch(user.$state, (_) => {
  if (user.isLoggedIn && user.specialLink) {
    actionAfterLogin(user.specialLink);
  }
});

const designRequest = () => {
  modalActive.value = true;
  console.log('designRequest');
}

const actionAfterLogin = (specialLink: string) => {
  router.push(specialLink);
};
</script>

<style scoped lang="scss">
.container {
  max-width: 1252px;
  padding: 0px $p-5;
  box-sizing: content-box;

  @media (max-width: 1300px) {
    box-sizing: border-box;
  }
}
</style>
